const $inject = [
  "$scope",
  "$uibModal",
  "HmrService",
  "TransactionService",
];

class TransactionController {
  /**
   * @constructor
   * @param $scope
   * @param $uibModal
   * @param {HmrService} HmrService
   * @param {TransactionService} TransactionService
   */
  constructor(
    $scope,
    $uibModal,
    HmrService,
    TransactionService
  ) {
    // Configuration
    this.itemsPerPage = 10;
    this.maxSize = 4;

    // Components
    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.HmrService = HmrService;
    this.TransactionService = TransactionService;

    // Entities
    this.pharmacist = {};
    this.transactions = [];

    // Variables
    this.totalItems = 0;
    this.currentPage = 1;

    // Initialisation
    this.cget();
  }

  /**
   * Get all the relevant transactions
   */
  cget() {
    var self = this;

    var handleSuccess = function (response) {
      if (!response.data.error) {
        self.loading = false;
        self.transactions = response.data.data.transactions;
        self.totalItems = response.data.data.total;
      }
      else {
        handleError(response);
      }
    };

    var handleError = function (response) {
      //TODO define behaviour
      self.loading = false;
    };

    this.loading = true;
    this.TransactionService.cget(this.itemsPerPage, this.currentPage - 1, handleSuccess, handleError);
  }

  /**
   * Refresh the list when paginating
   */
  pageChanged() {
    this.cget();
  }

  /**
   * Modify the number of items displaying per page
   * @param {Number}  num
   */
  setItemsPerPage(num) {
    this.itemsPerPage = num;
    this.currentPage = 1; //reset to first page
  }

  download_original_referral(hmr_id, item = null) {
    if (this.referralModalOpen) {
      return;
    }

    let self = this;
    this.referralModalOpen = true;

    let handleSuccess = function (response) {
      let contentDisposition = response.headers("Content-Disposition");
      if (contentDisposition) {
        let filename = contentDisposition.replace(/^(attachment|inline); *filename=/, "");
        let blob = new Blob([response.data], {type: response.headers("Content-Type")});
        let anchor = document.createElement("a");
        anchor.href = URL.createObjectURL(blob);
        anchor.download = filename;
        anchor.target = "_blank";
        anchor.click();
        self.referralModalOpen = false;
      }
      else if (response.headers("Content-Type" === "application/json")) {
        let data = JSON.parse(new TextDecoder().decode(response.data));
        if (!data.success) {
          handleError(response);
        }
        else {
          self.saving = false;
          self.$scope.file_download_route = "app.original-referral-download";

          self.$uibModal
            .open({
              animation: true,
              backdrop: true,
              templateUrl: "hmrOriginalReferralModal.html",
              controller: "HmrOriginalReferralModalController",
              controllerAs: "HmrOriginalReferralCtrl",
              resolve: {
                files: function () {
                  return data.data.files;
                },
              },
              scope: self.$scope,
            })
            .result.finally(function () {
            self.referralModalOpen = false;
          });
        }
      }
      else {
        handleError(response);
      }
    };

    let handleError = function (response) {
      self.saving = false;
      self.referralModalOpen = false;
    };

    this.HmrService.download_original_referral(hmr_id, item, handleSuccess, handleError);
  }
}

TransactionController.$inject = $inject;

export default TransactionController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/pharmacist/controllers/transaction.controller.js
 **/